import { Injectable } from '@angular/core';
import { HelperService } from '../shared/services/helper.service';
import { environment } from 'src/environments/environment';
import { HttpService } from '../shared/services/http.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class EmailService {

    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    
    constructor(private httpService: HttpService) { }

    public GetGiftCardsEmail(){
        this.URL = `${this.REQUEST_URL}/getGiftCardsEmail`;
        return this.httpService.get<any>(this.URL);
    }

    public GetGiftCardsEmailByType(params){
        this.URL = `${this.REQUEST_URL}/getGiftCardsEmailByType`;
        return this.httpService.post<any>(this.URL, params);
    }

    public GetGiftCardsEmailSend(params){
        this.URL = `${this.REQUEST_URL}/getGiftCardsEmailSend`;
        return this.httpService.post<any>(this.URL, params);
    }

    public GetGiftCardsEmailSendError(params){
        this.URL = `${this.REQUEST_URL}/getGiftCardsEmailSendError`;
        return this.httpService.post<any>(this.URL, params);
    }
    
    public CreateGiftCardEmail(params){
        this.URL = `${this.REQUEST_URL}/createGiftCardEmail`;
        return this.httpService.post<any>(this.URL, params);
    }

    public CreateGiftCardEmailSend(params){
        this.URL = `${this.REQUEST_URL}/createGiftCardEmailSend`;
        return this.httpService.post<any>(this.URL, params);
    }

    public UpdateGiftCardEmail(params){
        this.URL = `${this.REQUEST_URL}/updateGiftCardEmail`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateGiftCardEmailSend(params){
        this.URL = `${this.REQUEST_URL}/updateGiftCardEmailSend`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UploadFileSaveEmail(params){
        this.URL = `${this.REQUEST_URL}/uploadFileSaveEmail`;
        return this.httpService.post<any>(this.URL, params);
    }

    public UploadFileGiftCard(formData: any){
        const httpOptions = {
              headers: new HttpHeaders({
                'Accepted-Encoding': 'form-data'
          })
        };
        this.URL = `${this.REQUEST_URL}/uploadFileGiftCard`;
        return this.httpService.put<any>(this.URL, formData, httpOptions);
    }
    
    public SendEmailGiftCard(params){
        this.URL = `${this.REQUEST_URL}/sendEmailGiftCard`;
        return this.httpService.put<any>(this.URL, params);
    }
}